export default __webpack_public_path__ + "static/media/Plastic-Types_A1.2c092ef8.pdf";